const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_ScheduleWorkItems":
      return { ...state, WorkItems: payload };
    case "SAVE_ScheduleCalendar":
      return { ...state, Calendar: payload };
    case "SAVE_ScheduleTimeline":
      return { ...state, Timeline: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
